export default __webpack_public_path__ + "static/media/finalLanding.f2b462a8.PNG";